import { Link } from "react-router-dom";
import "../css/GamesUniform.css";

const FootballGames = () => {
    return (
        <main id="games-content">
            <h2 id="quest">What Football Game Would You Like To Play?</h2>

            <section id="games-section">
                <Link to="/football-guess-player" className="game-link">
                    <div className="game-card">
                        <h3>Guess the Football Player</h3>
                        <p>Identify the player from clues and stats.</p>
                    </div>
                </Link>

                <Link to="/football-memory-game" className="game-link">
                    <div className="game-card">
                        <h3>Memory Game</h3>
                        <p>Match the football team logo pairs on the board.</p>
                    </div>
                </Link>

                <Link to="/football-trivia" className="game-link">
                    <div className="game-card">
                        <h3>Trivia</h3>
                        <p>Test your football knowledge with quick questions.</p>
                    </div>
                </Link>
            </section>
        </main>
    );
};

export default FootballGames;